import { render, staticRenderFns } from "./WikiDisplay.vue?vue&type=template&id=39b78804&"
import script from "./WikiDisplay.vue?vue&type=script&lang=js&"
export * from "./WikiDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports